import { useSelector } from 'react-redux';
import { Box, Container } from '@chakra-ui/react';
import { PublicHeader } from './PublicHeader';
import { PublicFooter } from './PublicFooter';
import { GlobalAudioPlayer } from '../player/GlobalAudioPlayer';
import { FullPlayer } from '../player/FullPlayer';
import { RootState } from '../redux/store';

export function PublicShell({
  children,
  variant = 'inner',
}: {
  children: React.ReactNode;
  /** 'home' skips the inner container so the homepage can own full-bleed sections. */
  variant?: 'home' | 'inner';
}) {
  // When a track is queued the fixed-position player takes ~72px of bottom
  // space. Pad the shell so footer / last-row content isn't hidden behind it.
  const hasQueue = useSelector((s: RootState) => s.player.index >= 0);
  return (
    <Box minH="100vh" bg="night.900" color="whiteAlpha.900" display="flex" flexDirection="column" pb={hasQueue ? '84px' : 0}>
      <PublicHeader compact={variant === 'inner'} />
      <Box flex="1">
        {variant === 'home' ? (
          children
        ) : (
          <Container maxW="1200px" py={6} px={4}>
            {children}
          </Container>
        )}
      </Box>
      <PublicFooter />
      <GlobalAudioPlayer />
      <FullPlayer />
    </Box>
  );
}
